$(document).ready(function () {
  // General Message
  //--------------------------------------
  $('.generalmessage').prependTo('header');

  // Search Bar Script
  //--------------------------------------
  $('.searchBoxInput input').attr('placeholder', 'Search');
  $('.searchBoxInput input').val('');
  $('#mobileSearchInput').attr('placeholder', '');
  $('#mobileSearchInput').val('');


  // Header and mobile dropwdown code
  let logoCloned = $('.header-logo').css('background');
  $('.mobile-menu-header').prepend('<a href="/" class="dropdown-logo"></a>');
  $('.dropdown-logo').css('background', logoCloned);
  $('.mobile-menu-slider, .mobile-menu-footer-links').wrapAll('<div class="mobile-wrap"></div>');
  $('<div class="dropdown-footer"></div>').appendTo('.mobile-wrap');
  $('<a href="/email.aspx" class="updates-mobile">Get Updates</a>').appendTo('.dropdown-footer');
  $('.mobile-menu-container .search-container').appendTo('.dropdown-footer');



  // Mobile Dropdown edit
  $('.mobile-nav-toggle').on('click', function name() {
    $('#mobile-nav .prev-level-btn a').each(function () {
      let title = $(this);
      $(title).text('Back')
    });
  })

  // Footer logo cloned
  $('footer .footer-inner-container').prepend('<a class="footer-logo" href="/"></a>')
  $('.footer-logo').css('background', logoCloned);

});







